
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/reset",
      function () {
        return require("private-next-pages/reset.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/reset"])
      });
    }
  